import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

export default function SsoLogin() {
  const { token: tokenFromPath } = useParams();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromQuery = params.get('token');
    const tokenFromPathname = decodeURIComponent((location.pathname.split('/sso/')[1] || '')).trim();
    const rawToken = decodeURIComponent(tokenFromPath || tokenFromQuery || tokenFromPathname || '').trim();
    const normalizedToken = rawToken.startsWith('JWT ') ? rawToken.slice(4).trim() : rawToken;
    const looksLikeJwt = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(normalizedToken);

    if (!looksLikeJwt) {
      localStorage.removeItem('token');
      history.replace('/login?password=1&ssoError=invalid_token');
      return;
    }

    localStorage.setItem('token', `JWT ${normalizedToken}`);
    sessionStorage.removeItem('clinocta_sso_attempted');
    history.replace('/');
  }, [tokenFromPath, location.pathname, location.search, history]);

  return null;
}

